import React from "react";

export const Tooltips = [
  {
    id: "id",
    title: "title",
    pronunciation: "pronunciation",
    content: "content"
  },
  {
    id: "bacteria",
    title: "Bacteria",
    pronunciation: <>[bak-<strong>teer</strong>-ee-uh]</>,
    content: "Microscopic, single-celled organisms that thrive in diverse environments. These organisms can live in soil, the ocean, and inside the human gut"
  },
  {
    id: "bronchiectasis",
    title: "Bronchiectasis",
    pronunciation: <>[brong-kee-<strong>ek</strong>-tuh-sis]</>,
    content: "A disease in which there is permanent enlargement of parts of the airways of the lung. Symptoms typically include chronic cough with mucus production. Other symptoms include shortness of breath, coughing up blood, and chest pain"
  },
  {
    id: "COPD",
    title: "COPD  \n(chronic obstructive pulmonary disease)",
    pronunciation: <>[<strong>kron</strong>-ik] [uhb-<strong>struhkt</strong>-iv] [<strong>puhl</strong>-muh-ner-ee] [dih-<strong>zeez</strong>]</>,
    content: "A lung disease that leads to poor breathing. COPD is a term that is used to include chronic bronchitis, emphysema, or a combination of both"
  },
  {
    id: "asthma",
    title: "Asthma",
    pronunciation: <>[<strong>az</strong>-muh]</>,
    content: "An uncontrollable, often allergic breathing disorder that causes muscles in the airways of your lungs to tighten. This results in wheezing, coughing, and tightness in the chest"
  },
  {
    id: "MAC",
    title: <>MAC (<i>Mycobacterium avium</i> complex)</>,
    pronunciation: <>[mahy-koh-bak-<strong>tee</strong>r-ee-uhm] [<strong>ey</strong>-vee-uhm] [<strong>kom</strong>-pleks]</>,
    content: "The most common species of NTM bacteria found in the water and soil that can cause MAC lung disease"
  },
  {
    id: "macrophage",
    title: "Macrophage",
    pronunciation: <>[<strong>ma</strong>-kre-fayj]</>,
    content: "A type of white blood cell that helps eliminate foreign substances by surrounding foreign materials and initiating an immune response"
  },
  {
    id: "macrophages",
    title: "Macrophage",
    pronunciation: <>[<strong>ma</strong>-kre-fayj]</>,
    content: "A type of white blood cell that helps eliminate foreign substances by surrounding foreign materials and initiating an immune response"
  },
  {
    id: "spirometry",
    title: "Spirometry",
    pronunciation: <>[spy-<strong>rah</strong>-meh-tree]</>,
    content: "A common type of lung function test in which a patient blows into a tube connected to a machine called a spirometer. By measuring the ﬂow of air through the lungs and the amount of air in the lungs, a spirometry test helps to inform a healthcare provider how strong a patient’s lungs are"
  },
  {
    id: "MAC lung disease",
    title: <>MAC (<i>Mycobacterium avium</i> complex) lung disease</>,
    pronunciation: <>[mahy-koh-bak-<strong>teer</strong>-ee-uhm] [<strong>ey</strong>-vee-uhm] [<strong>kom</strong>-pleks] [luhng] [dih-<strong>zeez</strong>]</>,
    content: "The most common form of NTM lung disease, this type of noncontagious infection can cause serious damage to the lungs if left untreated"
  },
  {
    id: "CT scan",
    title: "Chest CT Scan",
    pronunciation: <>[chest] [skan]</>,
    content: "An X-ray image of the chest taken with \na scanner"
  },
  {
    id: "inflammation",
    title: "Inflammation",
    pronunciation: <>[in-ﬂuh-<strong>mey</strong>-shuhn]</>,
    content: "Redness, swelling, pain, tenderness, and heat in an area of the body"
  },
  {
    id: "Lung cavity",
    title: "Lung cavity",
    pronunciation: <>[luhng] [<strong>ka</strong>-vah-tee]</>,
    content: "An abnormal, empty, non-functional space within the lung visible on CT scan"
  },
  {
    id: "lung cavities",
    title: "Lung cavity",
    pronunciation: <>[luhng] [<strong>ka</strong>-vah-tee]</>,
    content: "An abnormal, empty, non-functional space within the lung visible on CT scan"
  },
  {
    id: "Mucus",
    title: "Mucus",
    pronunciation: <>[<strong>myoo</strong>-kuhs]</>,
    content: "A slimy mixture that is produced by glands lining your nose and throat. It also protects and lubricates surfaces in your body"
  },
  {
    id: "NTM",
    // title: "NTM (Nontuberculous mycobacteria)",
    // pronunciation: <>[nohn-too-<strong>bur</strong>-kyuh-luh s] [mahy-koh-bak-<strong>teer</strong>-ee-uh]</>,
    // content: "A type of bacteria found in the environment like the soil and water that can cause lung infections in some individuals"
    title: "NTM (Nontuberculous mycobacterial) lung disease",
    pronunciation: <>[nohn-too-<strong>bur</strong>-kyuh-luh s] [mahy-koh-bak-<strong>teer</strong>-ee l] [luhng] [dih-zeez]</>,
    content: "NTM lung disease is an infection that occurs in your lungs. The infection is caused by bacteria that are common in the environment"
  },
  {
    id: "nodule",
    title: "Nodule",
    pronunciation: <>[<strong>nah</strong>-jul]</>,
    content: "An abnormal growth in the lungs that occurs when a clump of immune cells (granuloma) calciﬁes or hardens over time"
  },
  {
    id: "nodules",
    title: "Nodule",
    pronunciation: <>[<strong>nah</strong>-jul]</>,
    content: "An abnormal growth in the lungs that occurs when a clump of immune cells (granuloma) calciﬁes or hardens over time"
  },
  {
    id: "chronic respiratory failure",
    title: "Chronic respiratory failure",
    pronunciation: <>[<strong>kron</strong>-ik] [<strong>res</strong>-per-uh-tawr-ee] [<strong>fāl</strong>yər]</>,
    content: "When the lungs are no longer able to exchange oxygen for carbon dioxide from the bloodstream fast enough for the body’s needs"
  },
  {
    id: "supplemental oxygen",
    title: "Supplemental oxygen",
    pronunciation: <>[<strong>suh</strong>-pluh-men-tahl] [<strong>ahks</strong>-i-jen]</>,
    content: "Also called oxygen therapy, this is additional oxygen supplied through a mask attached to a mechanical device or portable tank to assist people who have a low blood oxygen level"
  },
  {
    id: "ventilator",
    title: "Ventilator",
    pronunciation: <>[<strong>ven</strong>-te-lay-tor]</>,
    content: "A mechanized device that enables the delivery or movement of air and oxygen into the lungs of a patient whose breathing has ceased, is failing, or is inadequate"
  },
  {
    id: "lung resection",
    title: "Lung resection",
    pronunciation: <>[luhng] [re-<strong>sek</strong>-shun]</>,
    content: "A type of surgery used to diagnose and treat lung disorders. Surgeons can remove all or part of the lung"
  },
  {
    id: "hospitalization",
    title: "Hospitalization",
    pronunciation: <>[hah-spi-tuh-luh-<strong>zay</strong>-shun]</>,
    content: "The state of being admitted and treated at a hospital."
  },
];